/* eslint-disable react/prop-types */
import React, { useRef, useState } from 'react';
// import { putObject } from '@/utils/upload';
import { Button, message } from 'antd';
import GenerateTcVod, { getVodToken } from '../../utils/vodUplaod';
import { guuid } from '../../utils/utils';
// import { UploadOutlined } from '@ant-design/icons';

const Upload = (props) => {
  const {
    buttonText,
    buttonType,
    callback,
    videoUseageType,
    maxSize,
    beginCallback,
    style = {},
  } = props;
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const selectFile = () => {
    console.log(111);
    inputRef.current.click();
  };
  const fileChange = async (e) => {
    if (e.target.files.length === 0) {
      return;
    }
    const file = e.target.files[0];
    const fileType = file.name.substring(file.name.lastIndexOf('.') + 1);
    const types = ['MP4'];
    if (!types.includes(fileType.toUpperCase())) {
      message.warn('不支持此类型文件！');
      return;
    }

    if (maxSize && file.size > maxSize) {
      message.warn(
        '图片大小不能超过' + Math.floor(maxSize / (1024 * 1024)) + 'M',
      );
      return;
    }
    message.loading('上传中。。。');
    beginCallback && beginCallback();

    setLoading(true);
    const uuid = guuid();
    const getSignature = await getVodToken(
      undefined,
      undefined,
      uuid,
      videoUseageType || 1,
    );
    const tcVod = GenerateTcVod(getSignature);
    const uploader = tcVod.upload({
      mediaName: `${new Date().getTime()}` + '_' + file.name,
      mediaFile: file,
    });
    uploader.done().then((values) => {
      setLoading(false);
      message.success('上传成功！');
      inputRef.current.value = '';
      callback && callback(values, uuid);
      console.log(values);
    });

    // putObject({
    //   filename: file.name,
    //   file,
    //   // onProgress: (data)=>{
    //   //   // console.log(data)
    //   // },
    //   callback: (err, data) => {
    //     inputRef.current.value = '';
    //     // console.log(data);
    //     if (err) {
    //       message.error(err);
    //       return;
    //     }
    //     message.success('上传成功！');
    //     callback(data);
    //   },
    // });
  };
  return (
    <>
      <input
        type="file"
        ref={inputRef}
        style={{ display: 'none' }}
        onChange={fileChange}
        // accept=".WMV, .RM, .MOV,.MPEG,.MP4,.3GP, .FLV, .AVI, .RMVB"
        accept=".MP4,"
        // multiple="multiple"
      />
      <Button
        style={{ ...style }}
        type={buttonType || 'link'}
        onClick={selectFile}
        loading={loading}
      >
        {buttonText || '上传'}
      </Button>
    </>
  );
};
export default Upload;
